import {mapKeys} from 'utils/objects';
import {stateVals, mapStateKeys} from './_internal';

export default ({stateRemaps = {}}) => {
	const K = mapStateKeys(stateRemaps);
	return mapKeys(k => K[k], stateVals);
};
